/** Loads the codemode sandbox runtime on the first script (see execute.ts). */
export const loadCodemodeExecutor = () => import("./execute.ts");
